export const paths = {
    root: '/safetyAdmin',
    notifications: '/safetyAdmin/notifications',
    // reporting: '/safetyAdmin/reports/:reportName',
    actions: {
        create: '/safetyAdmin/createSafetyLetter',
        edit: '/safetyAdmin/:safetyId/edit',
        disable: '/safetyAdmin/:safetyId/disableSafetyLetterPopup',
        addComments: '/safetyAdmin/:safetyId/comments/addComments',
        setup: '/safetyAdmin/setupDistribution/:safetyId/:safetyCountryId',
        view: '/safetyAdmin/:safetyId/view',
    },
    details: {
        root: '/safetyAdmin/:safetyId',
        safetyReport: '/safetyAdmin/reports',
        individualRecipients: '/safetyAdmin/:safetyId/recipients/:organizationId'
    }
};

export const navigation = {
    actions: {
        editSafetyLetter: safetyId => `/safetyAdmin/${safetyId}/edit`,
        viewSafetyLetter: (safetyId, countryId = null) =>
            countryId
                ? `/safetyAdmin/${safetyId}/view?${countryId}`
                : `/safetyAdmin/${safetyId}/view`,
        disable: safetyId => `/safetyAdmin/${safetyId}/disableSafetyLetterPopup`,
        addComment: safetyId => `/safetyAdmin/${safetyId}/comments/addComments`,
        setup: (safetyId, countryId) => `/safetyAdmin/setupDistribution/${safetyId}/${countryId}`
    },
    details: {
        root: safetyId => `/safetyAdmin/${safetyId}`,
        individualRecipients: (safetyId, organizationId) =>
            `/safetyAdmin/${safetyId}/recipients/${organizationId}`,
        report: reportTypeSelected => `/safetyAdmin/reports/${reportTypeSelected}`
    }
};
